import type { FieldProps } from '../types';
import { useFieldContext } from '../hooks';
import { FieldBase } from './fieldBase';
import { Input, type InputProps } from '@e2n/ui/v2';

export function TextInput({
  label,
  description,
  isRequired,
  placeholder,
  className,
  infoText,
  suffix,
  ...inputProps
}: FieldProps & InputProps) {
  const field = useFieldContext<string | undefined>();
  const isInvalid = !field.state.meta.isValid;
  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      infoText={infoText}>
      <Input
        id={field.name}
        name={field.name}
        placeholder={placeholder}
        autoComplete="off"
        className={className}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        aria-invalid={isInvalid}
        onBlur={() => {
          field.setValue(field.state.value?.trim() ?? '');
          field.handleBlur();
        }}
        showSuffix={!!suffix}
        suffix={suffix}
        {...inputProps}
      />
    </FieldBase>
  );
}
